import { useLazyQuery } from '@apollo/client/react';

import { LoggerContextProps } from '../types/LogContext';
import { UseHookOptions } from '../types/UseHookOptions';
import { ChatMessage } from '../types/Chat';
import { GET_CHAT_MESSAGES } from '../queries/GetChatMessages';
import { handleError } from './errorHandler';

export function useGetChatMessages(options: UseHookOptions = {}) {
  const context: LoggerContextProps = {
    action: 'getChat',
    caseId: '',
    chatId: '',
  };
  const { useCache = true } = options;
  const [getChatMessagesQuery, { data, loading, error, refetch }] = useLazyQuery<{
    getChatMessages: { items: ChatMessage[] };
  }>(GET_CHAT_MESSAGES, {
    fetchPolicy: useCache ? 'cache-first' : 'no-cache',
  });

  const getChatMessages = async (caseId: string, chatId: string, forceRefresh = false) => {
    context.caseId = caseId;
    context.chatId = chatId;

    try {
      await getChatMessagesQuery({
        variables: {
          filter: {
            case_id: caseId,
            chat_id: chatId,
          },
        },
      });
    } catch (error) {
      handleError(error, context, 'Failed to get chat messages.');
    }
  };

  return { getChatMessages, refetch, data, loading, error };
}
